// Pagination constants
export const PAGINATION_LIMITS = {
  DEFAULT: 12,
  SMALL: 10,
  MEDIUM: 60,
  LARGE: 120,
  EXTRA_LARGE: 100,
} as const;

export const PAGINATION_OPTIONS = [
  // PAGINATION_LIMITS.SMALL,
  PAGINATION_LIMITS.DEFAULT,
  PAGINATION_LIMITS.MEDIUM,
  PAGINATION_LIMITS.LARGE,
] as const;

// Default pagination settings
export const DEFAULT_PAGINATION = {
  page: 1,
  limit: PAGINATION_LIMITS.DEFAULT,
} as const;
